import { h } from 'preact';
// import Store from 'store/store';
import * as categories from '../categories';
import * as didomiCategories from './categories';
import * as queue from '../queue';
import { dispatchEvent } from '../dispatchEvent';

export { default as Pixel } from '../Pixel';
export { maybeHandle } from '../maybeHandle';
export { default as connectToOneTrust } from '../oneTrust/connectToOneTrust';
export { default as createPixelComponent } from '../createPixelComponent';

export { STRICTLY_NECESSARY, FUNCTIONAL, TARGETING, ADVERTISING } from '../constants';
import { accessNested } from 'utils/utils';

categories.addChangeListener((allowedCategories) => {
	dispatchEvent('categoriesUpdated', { categories: allowedCategories });
});

categories.addChangeListener((allowedCategories) => {
	queue.drain(allowedCategories);
});

function getCookieCategories() {
	return window.Didomi.getUserConsentStatusForAll().purposes.enabled;
}

if (typeof window !== 'undefined') {
	const useDidomi = accessNested(window, '__INITIAL_STATE__.appData.options.didomiCookieConsent', false);
	let isDidomiInitialized = false;

	if (useDidomi) {
		if (!isDidomiInitialized) {
			window.didomiOnReady = window.didomiOnReady || [];
			window.didomiOnReady.push(function () {
				const activeGroups = getCookieCategories();
				didomiCategories.set(activeGroups);

				window.Didomi.on('consent.changed', function () {
					const newGroups = getCookieCategories();
					return didomiCategories.set(newGroups);
				});
			});

			isDidomiInitialized = true;
		}
	}
}
